var map = {
	"./add.png": "fbc1",
	"./auth.png": "ccd6",
	"./chatBg.png": "0f4c",
	"./copyIcon.png": "5923",
	"./en/logohaitunjinfu.png": "c005",
	"./icon1.png": "7d93",
	"./icon2.png": "9aa4",
	"./icon3.png": "e2a7",
	"./icon4.png": "bf40",
	"./loginBg.png": "3be2",
	"./logohaitunjinfu.png": "b378",
	"./nodata.png": "9485",
	"./pay0.png": "1236",
	"./pay1.png": "ddbd",
	"./pay2.png": "0851",
	"./pay3.png": "9eaf",
	"./pay4.png": "62f9",
	"./pay5.png": "c6ee",
	"./pay6.png": "5b5b",
	"./pay7.png": "9741",
	"./right.png": "0f2a",
	"./select.png": "0eb9",
	"./selectIcon.png": "dc9d",
	"./zh/logohaitunjinfu.png": "6378"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";